
export default {
  data () {
    return {
      tableColumns: [
        BaseTableColumn.initData('index'),
        BaseTableColumn.initData('merchantCompany', '商户名称', 100).setSpan({}),
        BaseTableColumn.initData('merchantTel', '商户电话', 100).setSpan({ canHidePhone: true }),
        BaseTableColumn.initData('officeName', '所属办事处', 100).setSpan({}),
        BaseTableColumn.initData('merchantStatusDesc', '开户状态', 100).setSpan({}),
        BaseTableColumn.initData('smsFlagDesc', '短信核验', 100).setSpan({}),
        BaseTableColumn.initData('relationNum', '已关联小区', 100).setValueButton([], (row, index) => {
          if (row.merchantStatus === 3) {
            this.dialog.associateModel = row;
          } else {
            row.relationNum.disabled = true;
          }
        },),
        // BaseTableColumn.initData('relationNum', '已关联小区', 100).setSpan({}),
        // BaseTableColumn.initData('totalAmount', '账户余额', 100).setSpan({ canPrice: true }),
        // BaseTableColumn.initData('accAmt', '可用余额', 100).setSpan({ className: 'col-text-strong', canPrice: true }),
        BaseTableColumn.initData('freezeAmount', '实际冻结金额', 100).setSpan({ canPrice: true }),
        BaseTableColumn.initData('warningAmount', '预警金额', 100).setSpan({ canPrice: true }),
        BaseTableColumn.initData('earlyWarningTels', '预警手机号码', 100).setSpan({ canHidePhone: true }),
        BaseTableColumn.initData('updateBy', '操作人', 100).setSpan({ canHidePhone: true }),
        BaseTableColumn.initData('updateTimeStr', '最近操作时间', 140).setSpan({}),
        BaseTableColumn.initData('setting', '操作').setWidth(80).setAlign('center').setRender((h, { row, index }) => {
          const buttonOptions = [
            { title: '商户详情', name: 'detail' },
            { title: '编辑商户', name: 'edit' }
            // { title: '关联小区', name: 'associate' }
            // { title: '短信核验', name: 'sms', permission: '', disabled: 'true' }
            // { title: '短信核验', name: 'sms', disabled: row.smsFlag !== 1 }
          ];
          // 只在已开户状态 merchantStatus === 3的状态下，展示关联小区
          if (row.merchantStatus === 3) {
            buttonOptions.push({ title: '关联小区', name: 'associate', disabled: row.merchantStatus !== 3 });
          }
          if (row.smsFlag === 1) {
            buttonOptions.push({ title: '短信核验', name: 'sms', disabled: row.smsFlag !== 1 });
          }
          return h('yg-table-buttons', {
            props: {
              items: buttonOptions
            },
            on: {
              'on-click': ({ name, disabled }) => {
                if (disabled) return;
                if (name === 'detail') {
                  this.requestDetail(row.id, name);
                } else if (name === 'edit') {
                  this.requestDetail(row.id, name);
                } else if (name === 'associate') {
                  this.dialog.associateModel = row;
                } else if (name === 'sms') {
                  this.$Modal.confirm({
                    title: '温馨提示',
                    content: '请确认商户信息已填写正确，点击确认后，第三方将向商户手机号发送短信，请提醒商户查看短信并核验身份。',
                    onOk: () => {
                      console.log('确定发送');
                      this.requestSmsCheck(row.id);
                    }
                  });
                }
              }
            }
          });
        })
      ]
    };
  }
};
